/**
 * /tenants/$slug/agents/activity — the buyer-facing "Agent activity" analytics page (AI Agents /
 * Agent governance area). Read-only, server-aggregated. Pivots by agent or user; optional ?id focus.
 */

import { createFileRoute } from "@tanstack/react-router";
import { activitySearchSchema } from "@/features/agent-activity/schemas";
import {
  fetchAgentActivity,
  activityQueryKey,
  DEFAULT_PIVOT,
  DEFAULT_WINDOW_DAYS,
  type ActivityParams,
} from "@/features/agent-activity/queries";
import { AgentActivityPage } from "@/features/agent-activity/pages/agent-activity-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/activity")({
  validateSearch: activitySearchSchema,
  loaderDeps: ({ search }): ActivityParams => ({
    pivot: search.pivot ?? DEFAULT_PIVOT,
    id: search.id,
    days: search.days ?? DEFAULT_WINDOW_DAYS,
    bucket: search.bucket,
  }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: activityQueryKey(context.tenant.id, deps),
      queryFn: () => fetchAgentActivity(context.tenant.id, deps),
    }),
  component: AgentActivityPage,
});
